
import { Link } from "react-router-dom";
import Rating from "../sidebar/rating";
import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";


const subTitle = "Get in touch with us";
const title = "We're Always Eager To Hear From You!";
const conSubTitle = "Get in touch with Contact us";
const conTitle = "Fill The Form Below So We Can Get To Know You And Your Needs Better.";
const btnText = "Submit Details";

const instructorList = [
    {
        imgUrl: 'assets/images/instructor/01.jpg',
        imgAlt: 'instructor rajibraj91 rajibraj',
        name: 'Emilee Logan',
        degi: 'Master of Education Degree',
        courseCount: '08 courses',
        studentAnroll: '30 students',
    },
    {
        imgUrl: 'assets/images/instructor/02.jpg',
        imgAlt: 'instructor rajibraj91 rajibraj',
        name: 'Donald Logan',
        degi: 'Master of Education Degree',
        courseCount: '08 courses',
        studentAnroll: '30 students',
    },
    {
        imgUrl: 'assets/images/instructor/03.jpg',
        imgAlt: 'instructor rajibraj91 rajibraj',
        name: 'Oliver Porter',
        degi: 'Master of Education Degree',
        courseCount: '08 courses',
        studentAnroll: '30 students',
    },
    {
        imgUrl: 'assets/images/instructor/04.jpg',
        imgAlt: 'instructor rajibraj91 rajibraj',
        name: 'Nahla Jones',
        degi: 'Master of Education Degree',
        courseCount: '08 courses',
        studentAnroll: '30 students',
    },
]


const Instructor = () => {
    const [captchaValue, setCaptchaValue] = useState(null);

    const handleCaptchaChange = (value) => {
      setCaptchaValue(value);
    };
    return (
        <div className="">
             <div className="p-4">
             <h2 className="text-center">Partner with us/Sign up agent</h2>

                <div className=" container row  mt-4">
                  
                    <div className="section-wrapper col-md-6 col-12 md:border-r border-gray-200 mt-4">
                        <h5>Personal Details</h5>
                        <form className="contact-form">
                            <div className="form-group">
                                <input
                                className=""
                                    type="text"
                                    name="name"
                                    placeholder="Your Name *"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="email"
                                    placeholder="Your Email *"
                                    required

                                />
                            </div>
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="email"
                                    placeholder="Confirm Email *"
                                    required

                                />
                            </div>
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="number"
                                    placeholder="Mobile Number"
                                />
                            </div>
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="number"
                                    placeholder="Whatsapp Number *"
                                    required

                                />
                            </div>
                            {/* <div className="form-group">
                                <input
                                    type="text"
                                    name="subject"
                                    placeholder="Your Subject *"
                                />
                            </div> */}
                            {/* <div className="form-group w-100">
                                <textarea 
                                    rows="8" 
                                    type="text"
                                    placeholder="Your Message"
                                ></textarea>
                            </div> */}
                            {/* <div className="form-group w-100 text-center">
                                <button className="lab-btn"><span>{btnText}</span></button>
                            </div> */}
                        </form>
                    </div>
                    <div className="section-wrapper col-md-6 col-12 mt-4  ">
                        <h5>Business Owner Details</h5>
                        <form className="contact-form">
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Company Name *"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="email"
                                    placeholder="Company Email *"
                                    required

                                />
                            </div>
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="number"
                                    placeholder="Company phone/whatsapp Number *"
                                    required

                                />
                            </div>
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="website"
                                    placeholder=" Website"
                                    required

                                />
                            </div>
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="website"
                                    placeholder=" Address *"
                                    required

                                />
                            </div>
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="website"
                                    placeholder=" City *"
                                    required

                                />
                            </div>
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="website"
                                    placeholder=" Country *"
                                    required

                                />
                            </div>
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="website"
                                    placeholder=" state *"
                                    required

                                />
                            </div>
                            {/* <div className="form-group w-100">
                                <textarea 
                                    rows="8" 
                                    type="text"
                                    placeholder="Your Message"
                                ></textarea>
                            </div> */}
                            {/* <div className="form-group w-100 text-center">
                                <button className="lab-btn"><span>{btnText}</span></button>
                            </div> */}
                        </form>
                    </div>
                    <div className="section-wrapper col-md-6 col-12 mt-4">
                        <h5>Financial Details</h5>
                        <form className="contact-form">
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Email ID for Commission verification *"
                                />
                            </div>
                            
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="number"
                                    placeholder="Whatsapp no for Commission verification *"
                                />
                            </div>
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="website"
                                    placeholder=" Phone No for Commission verification* "
                                />
                            </div>
                          
                          
                         
                           
                            {/* <div className="form-group w-100">
                                <textarea 
                                    rows="8" 
                                    type="text"
                                    placeholder="Your Message"
                                ></textarea>
                            </div> */}
                            {/* <div className="form-group w-100 text-center">
                                <button className="lab-btn"><span>{btnText}</span></button>
                            </div> */}
                        </form>
                    </div>
                    <div className="section-wrapper  flex justify-center items-center col-md-6 col-12 mt-4">
                    <div className="form-group">

<ReCAPTCHA
sitekey="YOUR_RECAPTCHA_SITE_KEY" // Replace with your Google reCAPTCHA site key
onChange={handleCaptchaChange}
/>
</div>
</div>

                    
                </div>
             
                          <div className="form-group mt-4 w-100 text-center">
                                <button className="lab-btn"><span>{btnText}</span></button>
                            </div>
            </div>
        </div>
    );
}
 
export default Instructor;